// extracted by mini-css-extract-plugin
export default {"verdictWrapper":"_nakxiIO","mobile":"mobile","verdictTitle":"a2WVdT09","text":"IOZ73j1I"};